import { VerticalSpace, Alert } from '@brokerbay/design-components';
import { Button, Card, Icon, Text, theme } from 'components';
import styled from 'styled-components';

export const BannerContainer = styled.div`
  flex-flow: row nowrap;
  align-items: center;
`;

export const StyledAlert = styled(Alert)`
  margin: 10px 0px;
  border-radius: 2px;
  border: 1px solid ${theme.blue3};
`;

export const StyledButton = styled(Button)`
  width: 100%;
  margin-top: 20px;
`;

export const StyledCard = styled(Card)`
  border: 1px solid ${theme.gray4};
`;

export const StyledHeading = styled(Text)`
  font-size: 20px;
`;

export const StyledList = styled(VerticalSpace)`
  margin-top: 10px;
`;

export const StyledListIcon = styled(Icon)`
  svg {
    height: 12px;
    weight: 12px;
  }
  margin-right: 5px;
`;

export const StyledIncludeListItem = styled(Text)`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${theme.gray8};
`;

export const StyledPrice = styled(Text)`
  font-size: 42px;
`;

export const StyledIncludesText = styled(Text)`
  font-size: 15px;
  margin-top: 30px;
`;

export const StyledPerAgentText = styled(Text)`
  color: ${theme.gray8};
`;

export const BANNER_HEIGHT = 40;
export const MOBILE_BANNER_HEIGHT = 80;

export enum BannerType {
  Wizard = 'wizard',
  PreLaunch = 'prelaunch',
  AgentPlanUpgrade = 'agentPlanUpgrade',
  None = 'none',
}
